import { Component, OnInit, Inject, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, ParamMap, Router, Event, RoutesRecognized, ActivatedRouteSnapshot, Params } from '@angular/router';

import { AddServiceComponent } from '../modals/add-service/add-service.component';
import { AddUserComponent } from '../modals/add-user/add-user.component';
import { EditDetailComponent } from '../modals/edit-detail/edit-detail.component';
import { Site } from '@app-models/site';
import { SiteService } from '@app-services/site.service';

import { AppURL } from '../../app.url';
import { Subscription } from 'rxjs';
import { LoadingScreenService } from '@app-services/loading-screen.service';


@Component({
  selector: 'app-site',
  templateUrl: './site.component.html',
  styleUrls: ['./site.component.scss']
})
export class SiteComponent implements OnInit, OnDestroy {

  childPath: string;
  childId: string;
  site: Site;
  logoUrl = 'assets/images/Default-Logo.png';
  serviceDialogRef: MatDialogRef<AddServiceComponent>;
  userDialogRef: MatDialogRef<AddUserComponent>;
  Url = AppURL;

  eventSubs: Subscription[];

  constructor(
    private ss: SiteService,
    private ls: LoadingScreenService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private cdkRef: ChangeDetectorRef) {
      this.childPath = '';
      this.childId = '';
    }

  ngOnInit() {
    this.eventSubs = [];
    if (this.route.firstChild) {
      const path = this.route.firstChild.routeConfig.path;
      if (path.indexOf('/') !== -1) {
        this.childPath = path.substring(0, path.indexOf('/'));
      } else {
        this.childPath = path;
      }
      this.route.firstChild.params.subscribe(
        (params: Params) => {
          if (params.serviceId) {
            this.childId = params.serviceId;
          }
          if (params.adminId) {
            this.childId = params.adminId;
          }
        }
      );
    } else {
      this.childPath = '';
      this.childId = '';
    }

    this.eventSubs.push(this.router.events.subscribe(
      (value: Event) => {
        if (value instanceof RoutesRecognized) {
          if (value.state.root.firstChild &&
                value.state.root.firstChild.firstChild &&
                value.state.root.firstChild.firstChild.firstChild) {
            const childRoute: ActivatedRouteSnapshot = value.state.root.firstChild.firstChild.firstChild;
            this.childPath = childRoute.url[0].toString();
            if (childRoute.url.length > 1) {
              this.childId = childRoute.url[1].toString();
            }
          }
        }
      }
    ));

    this.eventSubs.push(this.route.paramMap.subscribe(
      async (params: ParamMap) => {
        this.initSite(params.get('siteId'));
      }
    ));
    this.ss.imageUpdated.subscribe((site: Site) => {
      const ts = Math.round((new Date()).getTime() / 1000);
      this.logoUrl = this.site.logoUrl + '&ts=' + ts;
      this.cdkRef.detectChanges();
    });
  }

  initSite(siteId: string) {
    this.ls.startLoading();
    this.ss.getSite(siteId).then(
      (site: Site) => {
        this.site = site;
        this.ss.currentSite = site;
        this.logoUrl = site.logoUrl;
      }
    ).finally(() => { this.ls.stopLoading(); });
  }

  ngOnDestroy() {
    for (const sub of this.eventSubs) {
      sub.unsubscribe();
    }
  }

  editSite() {
    this.router.navigate(['site', this.site.id, this.Url.HospitalDetail]);
  }

  openServiceDialog() {
    this.serviceDialogRef = this.dialog.open(
      AddServiceComponent, {
        width: '450px',
        data: this.site.id
      }
    );
    this.serviceDialogRef.afterClosed().subscribe(
      (confirm: boolean) => {
        if (confirm) {
          // this.initSite(this.site.id);
        }
      }
    );
  }

  openUserDialog() {
    this.userDialogRef = this.dialog.open(
      AddUserComponent, {
        width: '450px',
        data: this.site.id
      });
    this.userDialogRef.afterClosed().subscribe(
      (confirm: boolean) => {
        if (confirm) {
          // this.initSite(this.site.id);
        }
      }
    );
  }
}


